(() => {
  const setup = async (tag, id) => {
    await customElements.whenDefined(tag);
    const drawer = document.getElementById(id);
    if (!drawer || drawer.dataset.p10Ready) return;
    drawer.dataset.p10Ready = 'true';
    // These two surfaces use their open attributes as the single scroll-lock source.
    Object.defineProperty(drawer, 'isLockingNeeded', { get: () => false });
    const afterShow = drawer.handleAfterShow.bind(drawer);
    drawer.handleAfterShow = function () { if (this.open) afterShow(); };
    drawer.handleAfterHide = function () {
      if (this.open) return;
      if (document.querySelector('#MenuDrawer[open],#CartDrawer[open],basic-modal[open],drawer-component[open]')) return;
      FoxTheme.a11y.removeTrapFocus();
      this.activeElement?.focus({ preventScroll: true });
      this.querySelectorAll('details[is=menu-drawer-details][open]').forEach(detail => detail.removeAttribute('open'));
    };
    const transition = show => new Promise(resolve => {
      let timer;
      const finish = () => { clearTimeout(timer); drawer.overlay.removeEventListener('transitionend', end); resolve(); };
      const end = event => { if (event.target === drawer.overlay) finish(); };
      drawer.overlay.addEventListener('transitionend', end);
      timer = setTimeout(finish, 280);
      if (show) requestAnimationFrame(() => { if (drawer.open) drawer.setAttribute('active', ''); });
      else drawer.removeAttribute('active');
    });
    drawer.handleShowTransition = () => {
      const other = document.getElementById(id === 'CartDrawer' ? 'MenuDrawer' : 'CartDrawer');
      if (other?.open) other.hide();
      return transition(true);
    };
    drawer.handleHideTransition = () => transition(false);
    const measure = () => {
      const viewport = window.visualViewport;
      drawer.style.setProperty('--p10-viewport-height', `${viewport?.height || window.innerHeight}px`);
      drawer.style.setProperty('--p10-viewport-top', `${viewport?.offsetTop || 0}px`);
    };
    measure();
    window.visualViewport?.addEventListener('resize', measure, { passive: true });
    window.visualViewport?.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    drawer.addEventListener('toggle', measure);
  };
  setup('menu-drawer', 'MenuDrawer');
  setup('cart-drawer', 'CartDrawer');
  document.addEventListener('shopify:section:load', () => { setup('menu-drawer', 'MenuDrawer'); setup('cart-drawer', 'CartDrawer'); });
})();
